import { useState, useEffect } from 'react';
import axios from 'axios';
import AppShell from '../components/layout/AppShell';
import AppFooter from '../components/layout/AppFooter';
import TopNav from '../components/layout/TopNav';

const API = process.env.REACT_APP_API_URL || "http://localhost:3001";

export default function TechnicianPayout({ onLogout, onNavigate }) {
  const [paypalEmail, setPaypalEmail] = useState('');
  const [savedEmail, setSavedEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [earnings, setEarnings] = useState(null);

  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };

  useEffect(() => { fetchPayout(); }, []); // eslint-disable-line

  async function fetchPayout() {
    try {
      const res = await axios.get(`${API}/technicians/payout`, { headers });
      setSavedEmail(res.data.paypal_email || '');
      setPaypalEmail(res.data.paypal_email || '');
      setEarnings(res.data.earnings);
    } catch {
      // pas encore de payout configuré
    }
  }

  async function savePayout() {
    if (!paypalEmail.trim()) return;
    setLoading(true);
    try {
      await axios.put(`${API}/technicians/payout`, { paypal_email: paypalEmail }, { headers });
      setSavedEmail(paypalEmail);
      setMessage({ text: 'Adresse PayPal enregistrée', type: 'success' });
    } catch {
      setMessage({ text: 'Erreur lors de la sauvegarde', type: 'error' });
    }
    setLoading(false);
    setTimeout(() => setMessage(null), 4000);
  }

  return (
    <AppShell
      header={<TopNav isLoggedIn={true} onLogout={onLogout} onNavigate={onNavigate} role="technicien" />}
      footer={<AppFooter onNavigate={onNavigate} />}
      onNavigate={onNavigate}
    >
      <div style={{ maxWidth: 600, margin: '0 auto', padding: '28px 20px' }}>
        <h1 className="page-title">Mes paiements</h1>

        {message && (
          <div className={`alert ${message.type === 'error' ? 'alert-error' : ''}`} style={{
            marginBottom: 16,
            ...(message.type !== 'error' ? {
              background: 'rgba(110,86,207,0.12)',
              borderColor: 'rgba(110,86,207,0.28)',
              color: '#a78bfa'
            } : {})
          }}>
            {message.text}
          </div>
        )}

        {/* Gains */}
        {earnings && (
          <div className="section-card" style={{ marginBottom: 20 }}>
            <div className="section-head">
              <h2 className="section-title">Revenus</h2>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
              <div style={{ padding: '16px', borderRadius: 12, background: 'rgba(110,86,207,0.08)', border: '1px solid rgba(110,86,207,0.2)' }}>
                <div className="muted" style={{ fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: 4 }}>Total gagné</div>
                <div style={{ fontSize: 22, fontWeight: 800, color: '#a78bfa' }}>{parseFloat(earnings.total || 0).toFixed(2)} €</div>
              </div>
              <div style={{ padding: '16px', borderRadius: 12, background: 'rgba(74,222,128,0.08)', border: '1px solid rgba(74,222,128,0.2)' }}>
                <div className="muted" style={{ fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: 4 }}>En attente</div>
                <div style={{ fontSize: 22, fontWeight: 800, color: '#4ade80' }}>{parseFloat(earnings.pending || 0).toFixed(2)} €</div>
              </div>
            </div>
          </div>
        )}

        {/* PayPal */}
        <div className="section-card">
          <div className="section-head">
            <h2 className="section-title">Recevoir mes paiements</h2>
          </div>
          <p className="muted" style={{ marginBottom: 16 }}>
            Liez votre adresse PayPal pour recevoir vos paiements après chaque intervention.
          </p>

          {savedEmail && (
            <div className="ticket-card" style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
              <span style={{ fontSize: 22 }}>🅿️</span>
              <div>
                <p style={{ fontWeight: 600, margin: '0 0 2px', fontSize: 14 }}>{savedEmail}</p>
                <p className="muted" style={{ margin: 0 }}>PayPal connecté</p>
              </div>
              <span className="badge" style={{ background: 'rgba(74,222,128,0.15)', borderColor: 'rgba(74,222,128,0.3)', color: '#4ade80', fontSize: 11, marginLeft: 'auto' }}>
                Actif
              </span>
            </div>
          )}

          <div style={{ display: 'flex', gap: 10 }}>
            <input
              type="email"
              placeholder="votre@email-paypal.com"
              value={paypalEmail}
              onChange={(e) => setPaypalEmail(e.target.value)}
              className="input"
              style={{ flex: 1 }}
            />
            <button
              className="btn btn-primary"
              onClick={savePayout}
              disabled={loading || !paypalEmail.trim()}
              style={{ whiteSpace: 'nowrap' }}
            >
              {loading ? '...' : savedEmail ? 'Modifier' : 'Enregistrer'}
            </button>
          </div>
        </div>
      </div>
    </AppShell>
  );
}